import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { pixelCardMotion } from './motion';
import { pixelChromeTone } from './palette';

export const pixelTheme: FlowThemeDefinition = {
  id: 'pixel',
  label: 'Pixel Quest',
  description: 'A 16-bit adventure: a hero hops island to island collecting a gem per question, then leaps to a castle for fireworks.',
  category: 'playful',
  chromeTone: pixelChromeTone,
  swatch: 'linear-gradient(180deg, #2557C4 0%, #84C3F2 45%, #4EA446 75%, #2460A8 100%)',
  cardGlass: 'dense',
  cardMotion: pixelCardMotion,
  burstSize: 300,
  softwareFriendly: true,
  loadScene: () => import('./scene').then((module) => module.createPixelScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
